import './locationUtils.js';
import { geocode } from './placesUtils.js';
import './jqueryOnAllEvents.js';

const MAX_LOCATION_AGE = 15 * 60 * 1000;

function locationError(error) {
    /* TODO:  error codes to use if we decide to log javascript errors around geoLocation
         switch(error.code) {
         case error.PERMISSION_DENIED:
         break;
         case error.POSITION_UNAVAILABLE:
         break;
         case error.TIMEOUT:
         break;
         case error.UNKNOWN_ERROR:
         break;
         }
         */
}

function lookUpGeocode(latitude, longitude, callback) {
    geocode(latitude, longitude,
        function (location) {
            window.createCookieWithMillisTimeout('geoLocationPlace', JSON.stringify(location), MAX_LOCATION_AGE);
            callback(location);
        },
    );
}

/**
 * Execute a callback once geolocation is detected
 * @param {function} callback The function to execute
 * @param {boolean=} suppressMobileDetection Whether to suppress location detection on mobile. Mobile location
 * detection requires the user to accept a prompt, which can be a bad experience in some cases.
 * @param useMaxMind Whether to use MaxMind location detection on mobile (it's very inaccurate there)
 */
export const detectLocation = function (callback, suppressMobileDetection = false, useMaxMind = false) {
    // Get location from cookie if possible
    const placesCookie = readCookie('geoLocationPlace');
    if (placesCookie) {
        callback(JSON.parse(placesCookie));
        return;
    }

    // If it's a mobile device, try to get the HTML5 location
    // MaxMind is very inaccurate on mobile devices
    if (isMobileDevice && navigator.geolocation && !useMaxMind) {
        if (suppressMobileDetection) return;

        $(document).on('googlePlacesLoaded', function () {
            let communityLinkTimer = null;
            function locationDetected(position) {
                clearTimeout(communityLinkTimer);

                // HTML5 location only gives us a lat/lng. We need Google Places to give state, city, etc.
                lookUpGeocode(position.coords.latitude, position.coords.longitude, callback);
            }

            // In firefox, if you click "not now" or if you close or ignore the permission window,
            // the geolocation error is never returned.
            // To compensate, second click and long timeout bypasses geolocation.
            navigator.geolocation.getCurrentPosition(locationDetected, locationError, {
                maximumAge: MAX_LOCATION_AGE,
                timeout: 5000,
            });
            communityLinkTimer = setTimeout(function () { locationError(null); }, 15000);
        });
    } else {
        $(document).onAll('geoCallComplete googlePlacesLoaded', function () {
            // We want to reverse geocode the MaxMind location for two reasons:
            // First, it doesn't provide a county and Places does. (update: this might not be true anymore)
            // Second, we're using it to standardize the lat/lon to be for the city instead of the individual's location.
            // This should help cache hits.
            lookUpGeocode(window.geoLocation.latitude, window.geoLocation.longitude, callback);
        });

        if (window.refreshGeoLocation) {
            refreshGeoLocation();
        } else {
            $(document).on('geocodeLoaded', function () {
                refreshGeoLocation();
            });
        }
    }
};
